export function useAbonadoRowActions(props, emit) {
    function getRowOptions(row) {
        const options = []
        const listaId = props.listaId

        if (props.teatro.hash === 'XSb8uxOmqRUI9fMC3Kos') {
            options.push({
                type: 'action',
                action: () => emit('modificar-estado', row.id),
                label: row.esta_renovado ? 'Anular' : 'Activar'
            })
        }

        options.push({
            to: { name: 'back.abonados.show', params: { lista_id: listaId, abonado_id: row.id } },
            label: `Ver ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abonado}`
        })

        if (row.user_id) {
            options.push({
                to: { name: 'back.usuarios.show-user', params: { lista_id: listaId, user_id: row.user_id } },
                label: 'Ver usuario'
            })
        }

        options.push({
            type: 'action',
            action: () => emit('enviar-abono', row.id),
            label: `Enviar ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abono}`
        })

        if (row.url_descargar) {
            options.push({
                type: 'url',
                url: row.url_descargar + '&tid=' + props.configuracion.hash_teatro,
                label: `Descargar ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abono}`
            })
        }

        if (row.esta_renovado && !props.manager.lfp) {
            options.push({
                to: { name: 'back.abonados.editar', params: { lista_id: listaId, abonado_id: row.id } },
                label: `Editar ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abonado}`,
                icon: 'pen'
            })

            if (row.url_imprimir) {
                options.push({
                    type: 'url',
                    url: row.url_imprimir,
                    label: `Imprimir ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abono}`,
                    icon: 'print'
                })
            }

            if (row.url_recibo) {
                options.push({
                    type: 'url',
                    url: row.url_recibo + '&tid=' + props.configuracion.hash_teatro,
                    label: 'Imprimir recibo',
                    icon: 'file-invoice'
                })
            }

            if (row.url_imprimir) {
                options.push({
                    type: 'url',
                    url: row.url_imprimir + '&cambiar_qr=true',
                    label: 'Reimpresión perdida',
                    icon: 'print'
                })
            }

            options.push({
                to: { name: 'back.abonados.show', params: { lista_id: listaId, abonado_id: row.id }, query: { tab: 'sanciones' } },
                label: 'Sanciones',
                icon: 'gavel'
            })

            options.push({
                to: { name: 'back.abonados.liberar.asiento', params: { lista_id: listaId, abonado_id: row.id } },
                label: 'Liberar asiento',
                icon: 'unlock'
            })

            if (props.permisos['abonos.devolver']) {
                options.push({
                    type: 'action',
                    action: () => emit('show-modal', 'anular-' + row.id),
                    label: 'Realizar devolución',
                    icon: 'undo'
                })
            }
        }

        if (!row.esta_renovado && props.permisos['abonos.devolver']) {
            options.push({
                type: 'action',
                action: () => emit('show-modal', 'borrar-' + row.id),
                label: `Borrar ${row.tipo ? props.teatro.texto_simpatizante : props.teatro.texto_abonado}`
            })
        }

        return options
    }

    return { getRowOptions }
}
